import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import School from './school';

const Education = (props) => {
	if (!_.isArray(props.data.education) || !props.data.education.length) {
		return null;
	}

	return (
		<ul className="bio-list">{_.map(props.data.education, data => <School data={data} key={_.uniqueId('school-')} />)}</ul>
	);
};

Education.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Education;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/education.js